<template>
  <section>
    <div class="ir-sub-menu">
      <ul class="col3">
        <li>
          <a href="/ir/governance" class="selected">コーポレート・ガバナンス</a>
        </li>
        <li>
          <a href="/ir/business">事業内容</a>
        </li>
        <li>
          <a href="/ir/disclosure_policy">
            ディスクロージャー
            <br class="sp" />ポリシー
          </a>
        </li>
      </ul>
    </div>

    <div class="l-service">
      <div class="l-service-header">
        <h2 class="heading-default heading-default-center">
          コーポレート・ガバナンス
        </h2>
        <h3 class="heading-small heading-small-center heading-small-mt-sp">
          CORPORATE GOVERNANCE
        </h3>

        <div class="l-service-content-inner">
          <h2 class="heading-coating heading-coating-small">
            コーポレート・ガバナンスの状況
          </h2>

          <!-- E-IR Parts -->
          <div id="eirArea"></div>
          <div id="doEirWrapper"></div>
          <!-- /E-IR Parts -->

          <h3 class="mission-panel-title">
            コーポレート・ガバナンスに関する基本的な考え方
          </h3>
          <p class="sentence sentence-mt">
            当社グループは、「国際交流の発展及び世界平和に貢献することと同時に、全従業員及び関係者の物心両面の充足と幸福を追求する」を経営理念に掲げ、当該経営理念に掲げられた姿を実現し、株主・従業員・お客様・取引先等のすべてのステークホルダーから信頼され、持続的な成長と中長期的な企業価値向上を図るため、透明・公正かつ迅速・果断な意思決定を実現するコーポレート・ガバナンスの充実・強化に継続的に取り組んでおります。今後も、その時々の社会的要請や当社を取り巻く環境を踏まえた実効的なコーポレート・ガバナンスの実現に努めてまいります。また、事業活動における透明性と客観性の確保も経営管理体制の強化に不可欠であることから、適切な情報公開を行ってまいります。
          </p>
          <p class="ir_img">
            <img src="img/governance.png" width height alt />
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "コーポレート・ガバナンス",
      titleTemplate:
        "コーポレート・ガバナンス | 経営方針 | IR情報 | 株式会社 旅工房",
    };
  },
  mounted: function () {
    let doEirWrapper = document.getElementById("doEirWrapper");
    let doEirScript = document.createElement("script");
    doEirScript.innerHTML = 'setParts("governance")';
    doEirWrapper.appendChild(doEirScript);
  },
};
</script>
